import { render, staticRenderFns } from "./WalletInvestmentGoalsSidebar.vue?vue&type=template&id=6bdb615a"
import script from "./WalletInvestmentGoalsSidebar.vue?vue&type=script&lang=js"
export * from "./WalletInvestmentGoalsSidebar.vue?vue&type=script&lang=js"
import style0 from "./WalletInvestmentGoalsSidebar.vue?vue&type=style&index=0&id=6bdb615a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports